export default __webpack_public_path__ + "static/media/fond.9090d834.jpg";